function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useRef, useState, useCallback } from 'react'; // This hook fixes any weird intermediate inconsistent/invalid/stale state values.
// https://github.com/facebook/react/issues/25023#issuecomment-1480463544

export default function useStateWithRepeatableRead(initialState) {
  // const latestValidState = useRef(initialState)
  var latestWrittenState = useRef(initialState);

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      _state = _useState2[0],
      _setState = _useState2[1]; // Instead of dealing with a potentially out-of-sync (stale) state value,
  // simply use the correct latest one.


  var state = latestWrittenState.current;
  /*
  let state
  if (_state === latestWrittenState.current) {
    state = _state
    latestValidState.current = _state
  } else {
    // React bug detected: an out-of-sync (stale) state value received.
    // Ignore the out-of-sync (stale) state value.
    state = latestValidState.current
  }
  */

  var setState = useCallback(function (newState) {
    if (typeof newState === 'function') {
      throw new Error('Function argument of `setState()` function is not supported by this hook');
    }

    latestWrittenState.current = newState;

    _setState(newState);
  }, []);
  return [state, setState];
}
//# sourceMappingURL=useStateWithRepeatableRead.js.map